import type { VNode } from "vue";
import Vue, { h } from "vue";

export const DetailCellRendererWrapper = Vue.extend({
  name: "DetailCellRendererWrapper",
  render(): VNode {
    const params = (this as any).params;
    return h(
      "div",
      params.renderFn({
        item: params.data,
      })
    );
  },
});
